<template>
    <div v-if="values">
        <v-row>
            <v-col cols="12" class="text-center">
                <v-row>
                    <v-col cols="12">
                        <v-btn color="primary" @click="connectSerial" v-if="!isConnected">
                            <v-icon left>mdi-usb</v-icon>
                            Conectar escáner
                        </v-btn>
                        <v-btn color="error" @click="disconnectSerial" v-if="isConnected">
                            <v-icon left>mdi-usb</v-icon>
                            Desconectar escáner
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <autocompleteMultipleForm label="Checadores" :valueInput="fingerprint_scanners" :loading="scannersList.loading" :rule="[]"
                            :items="scannersList.items" @valueChange="
                                    (v) => {
                                        fingerprint_scanners = v;
                                        delete serverErrors.fingerprint_scanners;
                                    }
                                " :errorMessages="[]"></autocompleteMultipleForm>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" v-if="isConnected">
                        <fingerprint-reading-button title="Registrar huella 1" success-title="Huella 1 registrada" @click="openDialog(0)"
                            :error-messages="fingerprintReadings[0].errors"
                            :complete="fingerprintReadings[0].complete"></fingerprint-reading-button>
                    </v-col>

                    <v-col cols="12" v-if="isConnected">
                        <fingerprint-reading-button title="Registrar huella 2" success-title="Huella 2 registrada" @click="openDialog(1)"
                            :error-messages="fingerprintReadings[1].errors"
                            :complete="fingerprintReadings[1].complete"></fingerprint-reading-button>
                    </v-col>

                    <v-col cols="12" v-if="isConnected">
                        <fingerprint-reading-button title="Registrar huella 3" success-title="Huella 3 registrada" @click="openDialog(2)"
                            :error-messages="fingerprintReadings[2].errors"
                            :complete="fingerprintReadings[2].complete"></fingerprint-reading-button>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <!-- MODAL TO UPLOAD FINGERPRINT READING -->
        <modal :props="modalAddFingerPrintReading" @modalResponse="method_handler" persistent>
            <!-- Body -->

            <template slot="cardBody">
                <div class="py-12 text-center">



                    <v-progress-circular :value="modalAddFingerPrintReading.progress" color="success" rotate="360"
                        size="200" width="6" rounded>
                        <div class="d-flex flex-column align-items-center">

                            <v-icon color="success" size="128">
                                mdi-fingerprint
                            </v-icon>
                            <div class="text-headline-large text-medium-emphasis">
                                {{ modalAddFingerPrintReading.progress.toFixed() }} %
                            </div>
                        </div>
                    </v-progress-circular>

                </div>
            </template>
            <!-- Buttons -->
            <template slot="cardActions">
                <v-row justify="center">
                    <v-col cols="12" md="4">
                        <secondaryButton :props="cancelModal"></secondaryButton>
                    </v-col>
                    <v-col cols="12" md="4">
                        <primaryButton v-if="modalAddFingerPrintReading.progress >= 100" :props="acceptModal">
                        </primaryButton>
                    </v-col>
                </v-row>
            </template>
        </modal>

    </div>



</template>
<script>
import Utils from '@/helpers/Utils.js';

import FingerPrintDeviceStorage from '@/helpers/figer-print-device.storae.js';
import fingerprintReadingButton from './fingerprint-reading-button.vue';

// [
//     {
//         "type": "waiting_finger",
//         "step": 1,
//         "employeeID": 0,
//         "attempt": 1
//     },
//     {
//         "type": "capture_ok",
//         "step": 1,
//         "employeeID": 0
//     },
//     {
//         "type": "remove_finger",
//         "employeeID": 0
//     },
//     {
//         "type": "finger_detected"
//     },
//     {
//         "type": "waiting_finger",
//         "step": 2,
//         "employeeID": 0,
//         "attempt": 1
//     },
//     {
//         "type": "finger_released"
//     },
//     {
//         "type": "capture_ok",
//         "step": 2,
//         "employeeID": 0
//     },
//     {
//         "type": "enroll_ok",
//         "employeeID": 0,
//         "template": "AwNUMgQBNAFtAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAAAAIkAADADMzM8/z/M/7//+++7uqqqqqqZmZllVVVVVVFFFEEARAEBAQEAAAAAAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAAAAAAASwO8B/////wIAgjGKgR4ZEhJ+ZxaFXlEdhr5qssdeJjQGPmE9yv5lQcy+NMYsXksIwt9moZwfYSWHHxoni19HLQr/Iy3G3zmu3n8bMMg/DrHJP2E2CF8RN59fVS3InSuwh51MtcsdVLgKPU47DT1EnRnaJ77dGlhGYpoixxw6MzRn7wH/////AgCCRh+G2y0jjHstJclbT6uKGzy2IjssvUIYUELTeDSzm/khQ8aWXkZjVjK2XJcyuN43HkRbl2DHkrc5uluVSkKksz261o89OqLNAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgY+8B/////wIAggMDUjIAASABbwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcAAACDAAAAAAPMMz/PPz///+/v7u6qqqqqpmmZZVVVVVVRRRREQAAAAAAAAAAAAAAAAAAAAAAAAAA="
//     },
//     {
//         "type": "finger_detected"
//     },
//     {
//         "type": "finger_released"
//     }
// ]

const types = {
    WAITING_FINGER: 'waiting_finger',
    CAPTURE_OK: 'capture_ok',
    CAPTURE_ERROR: 'capture_error',
    REMOVE_FINGER: 'remove_finger',
    FINGER_DETECTED: 'finger_detected',
    FINGER_RELEASED: 'finger_released',
    ENROLL_OK: 'enroll_ok',
    ENROLL_ERROR: 'enroll_error'

};

export default {
    props: ['values', 'serverErrors', 'edit'],

    name: "FingerPrintForm",
    components: {
        fingerprintReadingButton,
    },

    data() {
        return {
            employeeID: null,
            reading_number: 0,
            interval: {},// just to test
            fingerprintData: null,
            port: null,
            isConnected: false,
            incomingData: "",
            reader: null,
            baudRate: 115200, // Set your desired baud rate here
            esp32Filters: [
                { usbVendorId: 4097, usbProductId: 12346 } // Vendor ID estándar de Espressif, Product ID del ESP32C3
            ],
            modalAddFingerPrintReading: {
                visible: false,
                width: '700',
                title: 'Registrar huella',
                text: '',
                loading: false,
                bottomLineColor: 'primary',
                progress: 0,
                persistent: true,
            },
            cancelModal: {
                text: "CANCELAR",
                icon: "",
                to: "",
                block: true,
                color: '',
                click: () => { this.closeModal() }
            },
            acceptModal: {
                text: "GUARDAR",
                icon: "",
                to: "",
                block: true,
                color: 'error',
                textColor: 'white',
                textColorLevel: '0',
                loading: false,
                click: () => { this.acceptFingerReading() }
            },
            fingerprint_scanners: [],
            fingerprintReadings: [
                { errors: [], complete: false },
                { errors: [], complete: false },
                { errors: [], complete: false },
            ],
            scannersList: {
                items: [],
                loading: false,
            },
            fingerprintReading: null
        };
    },
    watch: {
        fingerprint_scanners(newVal) {
            this.values.fingerprint_scanners = newVal.map(item => { return { fingerprint_scanner_id: item }; });
        }
    },
    methods: {
        method_handler(object) {
            this[object.method_name](object.parameters)
        },
        closeModal() {
            this.modalAddFingerPrintReading.visible = false;
        },
        acceptFingerReading() {
            console.log(this.values);

            if (this.values['fingerprints'] === undefined) {
                this.values['fingerprints'] = [];
            }
            this.values['fingerprints'][this.reading_number] = { data: this.fingerprintReading };
            this.fingerprintReadings[this.reading_number].complete = true;
            this.modalAddFingerPrintReading.visible = false;
        },
        openDialog(reading) {
            this.reading_number = reading;
            this.modalAddFingerPrintReading.progress = 0;
            this.fingerprintReadings[this.reading_number].errors = [];
            this.attemptToReadFingerprint(); //start device readings
            console.log(`Opening dialog for reading ${reading}`);
            // Implement the logic to open the dialog here
            this.modalAddFingerPrintReading.visible = true;
            console.log("Dialog opened");
        },
        getScanners() {
            this.scannersList.loading = true;

            this.$api.scanner.index()
                .then((resp) => {
                    this.scannersList.items = resp.data.map((x) => ({ value: x.id, text: x.name }));
                })
                .catch((error) => {
                    console.log(error, "error desde areas");
                })
                .finally(() => {
                    this.scannersList.loading = false;
                })
                ;

        },
        async connectSerial() {
            if (!("serial" in navigator)) {
                alert("Web Serial API not supported in this browser. Use Chrome or Edge.");
                return;
            }
            try {
                // Request permission to connect to a device
                const port = await navigator.serial.requestPort();
                await port.open({ baudRate: this.baudRate }); // Match your microcontroller speed
                const info = port.getInfo();
                this.port = port;
                this.isConnected = true;

                FingerPrintDeviceStorage.setId(info.usbVendorId); // Store the port info for auto-reconnect
                // this.attemptToReadFingerprint(); // Start reading fingerprint data after connecting

                // Start listening for data
                this.readData();
                // Optionally, you can start reading data immediately after connecting

            } catch (error) {
                console.error("Connection failed:", error);
            }
        },
        async attemptToReadFingerprint() {
            if (!this.isConnected) {
                alert("No hay conexión con el escáner de huellas digitales.");
                return;
            }
            try {
                //send command to the ESP32 to read fingerprint, {"type":"start_enroll","employeeID":123}
                const command = { type: "start_enroll", employeeID: this.employeeID };
                console.log("Sending command to start fingerprint enrollment:", command);

                if (this.port.writable) {
                    const writer = this.port.writable.getWriter();
                    const encoder = new TextEncoder();

                    // Es crucial agregar "\n" para que el ESP32 detecte el final del comando
                    const datosSeralizados = encoder.encode(JSON.stringify(command) + "\n");

                    await writer.write(datosSeralizados);
                    console.log(`Comando "${JSON.stringify(command)}" enviado con éxito.`);
                    // // Inicia la lectura de datos después de enviar el comando
                    // this.readData();
                    // Libera el flujo para evitar bloqueos futuros
                    writer.releaseLock();
                } else {
                    console.error("El puerto no es escribible. Verifica la conexión.");
                }

            } catch (error) {
                console.error("Error al leer la huella digital:", error);
            }
        },
        async readData() {
            console.log("Attempting to read data from the serial port...");
            console.log("Current port:", this.port);
            console.log("Is connected:", this.isConnected);
            console.log("Is readable:", this.port ? this.port.readable : "No port available");
            // 1. Ensure we only run if connected and not already reading
            if (!this.port || !this.port.readable || !this.isConnected) return;
            try {
                // 2. Lock the reader ONCE
                this.reader = this.port.readable.getReader();
                console.log("Reader locked, starting to read data...");

                // 3. Keep reading until the stream closes or we disconnect
                /* eslint-disable-next-line no-constant-condition */
                while (this.isConnected) {
                    const { value, done } = await this.reader.read();
                    if (done) break;

                    // Convert raw bytes to text
                    this.incomingData += new TextDecoder().decode(value);

                    const parsedData = this.incomingData.trim();
                    if (parsedData) {
                        try {
                            const lines = parsedData.split("\n");
                            const jsonData = lines.filter(line => line.trim() !== "").map(line => JSON.parse(line));
                            const lastEntry = jsonData.at(-1);

                            if (!lastEntry || !lastEntry.type) {
                                continue;
                            }

                            console.log("Last entry:", lastEntry);
                            switch (lastEntry.type) {
                                case types.WAITING_FINGER:
                                    // Handle waiting finger
                                    if(lastEntry.step === 2){
                                        this.modalAddFingerPrintReading.progress += 55;
                                    }

                                    break;
                                case types.CAPTURE_OK:
                                    if(lastEntry.step === 2){
                                        this.modalAddFingerPrintReading.progress += 32;
                                    }
                                    break;
                                case types.REMOVE_FINGER:
                                    // Handle remove finger
                                    break;
                                case types.FINGER_DETECTED:
                                    // Handle finger detected
                                    break;
                                case types.FINGER_RELEASED:
                                    // Handle finger released
                                    break;
                                case types.ENROLL_OK:
                                    // Handle enroll ok
                                    this.modalAddFingerPrintReading.progress = 100;
                                    this.fingerprintReading = lastEntry.template;
                                    break;
                                case types.CAPTURE_ERROR:
                                    // Handle capture error
                                    this.fingerprintReadings[this.reading_number].errors.push("Error de captura");
                                    this.modalAddFingerPrintReading.visible = false;
                                    break;
                                case types.ENROLL_ERROR:
                                    // Handle enroll error
                                    this.fingerprintReadings[this.reading_number].errors.push("Error leyendo la huella");
                                    this.modalAddFingerPrintReading.visible = false;
                                    break;
                                default:
                                    console.warn("Unknown type:", lastEntry.type);
                            }
                        } catch (e) {
                            // console.error("Error parsing JSON data:", e);
                        }
                        finally {
                            // Clear the buffer after processing
                            // console.log("Received data:", this.incomingData);
                        }
                    }
                }
            } catch (error) {
                console.error("Read error:", error);
            } finally {
                // 4. Always release the lock when exiting so it can be read again later
                if (this.reader) {
                    this.reader.releaseLock();
                    this.reader = null; // Clear it out safely
                }
            }
        },
        async disconnectSerial() {
            this.isConnected = false;
            // 1. Cancelar y liberar el lector primero
            if (this.reader) {
                try {
                    await this.reader.cancel();
                    this.reader.releaseLock();
                } catch (e) {
                    console.log("El lector ya estaba cerrado o liberado:", e);
                }
                this.reader = null;
            }

            // 2. Cerrar el puerto de forma segura
            if (this.port) {
                try {
                    // Solo intentamos cerrar si el puerto sigue abierto en el navegador
                    await this.port.close();
                } catch (error) {
                    // Captura el InvalidStateError si el puerto ya se había cerrado solo
                    console.warn("El puerto ya estaba cerrado, limpiando referencias locales.");
                } finally {
                    // Siempre destruimos la referencia en Vue para evitar fugas de memoria
                    this.port = null;
                }
            }
            // if (this.reader) await this.reader.cancel();
            // if (this.port) await this.port.close();
            // this.port = null;
            // this.reader = null;
            FingerPrintDeviceStorage.removeId(); // Clear stored port info on disconnect
        },
        async autoConnect() {
            try {
                const ports = await navigator.serial.getPorts();
                for (const port of ports) {
                    const info = port.getInfo();
                    console.log('Puerto disponible:', info);
                }
                // Buscamos si entre los puertos autorizados está nuestro ESP32
                const storedVendorId = +FingerPrintDeviceStorage.getId();
                const authorizedPort = ports.find(port => {
                    const info = port.getInfo();
                    return info.usbVendorId === storedVendorId;
                });

                if (authorizedPort) {
                    this.port = authorizedPort;
                    await this.openPort();
                    console.log('Reconectado automáticamente al ESP32C3');
                    this.readData();
                }
            } catch (error) {
                console.error('Error en la reconexión automática:', error);
            }
        },
        // Abre el canal de comunicación
        async openPort() {
            // Configura los baudios según tu código de Arduino/ESP-IDF (ej. 115200)
            await this.port.open({ baudRate: this.baudRate });
            this.isConnected = true;
        },
        async checkConnection() {
            if (this.port) {
                try {
                    await this.port.getInfo(); // This will throw if the port is closed
                    this.isConnected = true;
                } catch (error) {
                    this.isConnected = false;
                }
            }
        },
    },
    mounted() {
        this.getScanners();
        // this.checkConnection();
        this.autoConnect();

        // Escuchar si el dispositivo se desconecta físicamente
        navigator.serial.addEventListener('disconnect', (event) => {
            if (event.target === this.port) {
                this.disconnectSerial();
                alert('ESP32C3 desconectado físicamente.');
            }
        });

        this.employeeID = Utils.generateUUID(8);
    },
    beforeDestroy() {
        clearInterval(this.interval)
    },
};


</script>
